import { useSiteContext } from 'application/contexts/SiteContext';
import { usePageContext } from 'application/contexts/PageContext';
import { JsonLdScript } from './JsonLdScript';

// Structured-data only, by design - the site has no visible breadcrumb trail, but Google/AI still
// benefit from the markup.
export const BreadcrumbJsonLd: React.FC = () => {
	const pageContext = usePageContext();
	const siteContext = useSiteContext();

	const items = pageContext?.breadcrumb;
	if (!items?.length) return null;

	const baseUrl = siteContext?.url?.replace(/\/$/, '');

	const data = {
		'@context': 'https://schema.org',
		'@type': 'BreadcrumbList',
		itemListElement: items.map((item, index) => ({
			'@type': 'ListItem',
			position: index + 1,
			name: item.title,
			item: baseUrl ? `${baseUrl}${item.url}` : item.url,
		})),
	};

	return <JsonLdScript id="breadcrumb-jsonld" data={data} />;
};
